import { useState } from "react";
import { Plus, Sparkles, Loader2, Download } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// FIN-6 — Toolbar.
// Esquerda: pills de status (Todas/Ativas/Pausadas/Canceladas).
// Direita: Detectar (amber) + Exportar + Novo (primary).

export default function AssinaturasToolbar({
  statusFilter,
  onChangeStatus,
  statusOptions,
  exportCsv,
  onCreate,
  onDetect,
  isLoadingSuggestions,
}) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const out = await exportCsv();
      toast.success(`Exportado: ${out.filename}`);
    } catch (e) {
      toast.error(e.message || "Falha ao exportar");
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3" data-testid="sub-toolbar">
      {/* Pills de status */}
      <div className="inline-flex flex-wrap gap-1.5 bg-surface-card-hover/40 border border-subtle rounded-lg p-1" role="group" aria-label="Filtro de status">
        {statusOptions.map(s => {
          const isActive = statusFilter === s;
          return (
            <button
              key={s}
              type="button"
              aria-pressed={isActive}
              onClick={() => onChangeStatus(s)}
              className={cn(
                "px-2.5 py-1 rounded-md text-caption font-medium transition-all duration-fast",
                isActive
                  ? "bg-brand-cyan/15 border border-brand-cyan/40 text-brand-cyan"
                  : "border border-transparent text-foreground-muted hover:bg-surface-card-hover hover:text-foreground",
              )}
              data-testid={`sub-filter-${s.toLowerCase()}`}
            >
              {s}
            </button>
          );
        })}
      </div>

      {/* Ações */}
      <div className="flex items-center gap-2 self-end md:self-auto flex-wrap">
        <Button
          variant="ghost"
          size="md"
          onClick={onDetect}
          disabled={isLoadingSuggestions}
          className="text-status-warning hover:text-status-warning hover:bg-status-warning/10"
          data-testid="sub-detect-btn"
        >
          {isLoadingSuggestions ? (
            <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />
          ) : (
            <Sparkles className="w-4 h-4" aria-hidden="true" />
          )}
          Detectar assinaturas
        </Button>
        <Button
          variant="ghost"
          size="md"
          onClick={handleExport}
          disabled={exporting}
          data-testid="sub-export-btn"
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          <span className="hidden md:inline">Exportar</span>
        </Button>
        <Button variant="primary" size="md" onClick={onCreate} data-testid="sub-create-btn">
          <Plus className="w-4 h-4" /> Nova assinatura
        </Button>
      </div>
    </div>
  );
}
